import React from "react";

import { Props, CircleProps } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function Circle({ size, progress, strokeWidth, color }: CircleProps) {
  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = ((100 - progress) / 100) * circumference;

  return (
    <circle
      className={styles.bar}
      cx={center}
      cy={center}
      r={radius}
      strokeWidth={strokeWidth}
      strokeDasharray={circumference}
      strokeDashoffset={offset}
      style={{ stroke: color }}
    />
  );
}

function Graph({ synthesis }: Props) {
  const size = 145;
  const girth = 22;

  return (
    <div className={styles.graph}>
      <svg className={styles.progressBar} width={size} height={size}>
        <circle
          className={styles.bar}
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - girth / 2}
          strokeWidth={girth}
          style={{ stroke: "#FF8E4319" }}
        />
        <Circle
          color="#FD742E"
          strokeWidth={girth}
          size={size}
          progress={
            synthesis.percentOfPlannedValueOfInternalResourcesOfProject +
            synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
            synthesis.percentOfPlannedValueOfMaterialResourcesOfProject
          }
        />
        <Circle
          color="#CBDDF7"
          strokeWidth={girth}
          size={size}
          progress={
            synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
            synthesis.percentOfPlannedValueOfInternalResourcesOfProject
          }
        />
        <Circle
          color="#FDA439"
          strokeWidth={girth}
          size={size}
          progress={synthesis.percentOfPlannedValueOfExternalResourcesOfProject}
        />
      </svg>
      <Icon className={styles.icon} />
      {synthesis.percentOfPlannedValueOfMaterialResourcesOfProject > 0 && (
        <div
          className={styles.clock}
          style={{
            transform: `rotate(${
              ((synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
                synthesis.percentOfPlannedValueOfInternalResourcesOfProject +
                synthesis.percentOfPlannedValueOfMaterialResourcesOfProject) /
                100) *
                360 -
              90
            }deg) translate(-50%, -50%)`,
          }}
        >
          <p
            style={{
              transform: `rotate(-${
                ((synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
                  synthesis.percentOfPlannedValueOfInternalResourcesOfProject +
                  synthesis.percentOfPlannedValueOfMaterialResourcesOfProject) /
                  100) *
                  360 -
                90
              }deg)`,
            }}
          >
            {synthesis.percentOfPlannedValueOfMaterialResourcesOfProject}%
          </p>
        </div>
      )}
      {synthesis.percentOfPlannedValueOfInternalResourcesOfProject > 0 && (
        <div
          className={styles.clock}
          style={{
            transform: `rotate(${
              ((synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
                synthesis.percentOfPlannedValueOfInternalResourcesOfProject) /
                100) *
                360 -
              90
            }deg) translate(-50%, -50%)`,
          }}
        >
          <p
            style={{
              transform: `rotate(-${
                ((synthesis.percentOfPlannedValueOfExternalResourcesOfProject +
                  synthesis.percentOfPlannedValueOfInternalResourcesOfProject) /
                  100) *
                  360 -
                90
              }deg)`,
            }}
          >
            {synthesis.percentOfPlannedValueOfInternalResourcesOfProject}%
          </p>
        </div>
      )}
      {synthesis.percentOfPlannedValueOfExternalResourcesOfProject > 0 && (
        <div
          className={styles.clock}
          style={{
            transform: `rotate(${
              (synthesis.percentOfPlannedValueOfExternalResourcesOfProject /
                100) *
                360 -
              90
            }deg) translate(-50%, -50%)`,
          }}
        >
          <p
            style={{
              transform: `rotate(-${
                (synthesis.percentOfPlannedValueOfExternalResourcesOfProject /
                  100) *
                  360 -
                90
              }deg)`,
            }}
          >
            {synthesis.percentOfPlannedValueOfExternalResourcesOfProject}%
          </p>
        </div>
      )}
    </div>
  );
}

export { Graph };
